"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceLanes = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
class SpaceLanes extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.SPACE_LANES,
            tags: [Tags_1.Tags.SPACE],
            cardDiscount: [{ tag: Tags_1.Tags.JOVIAN, amount: 2 }, { tag: Tags_1.Tags.EARTH, amount: 2 }, { tag: Tags_1.Tags.VENUS, amount: 2 }],
            metadata: {
                cardNumber: 'P62',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.titanium(3);
                    b.preludeBox('effect', (ce) => {
                        ce.effect('When you play a Jovian, Earth or Venus tag, you pay 2 M€ less for it.', (eb) => {
                            eb.jovian().played.slash().earth().played.slash().venus(1).played.startEffect.megacredits(-2);
                        });
                    });
                }),
                description: 'Gain 3 titanium.',
            },
        });
    }
    getCardDiscount(_player, card) {
        const eligibleTags = [Tags_1.Tags.JOVIAN, Tags_1.Tags.EARTH, Tags_1.Tags.VENUS];
        return card.tags.filter((tag) => eligibleTags.includes(tag)).length * 2;
    }
    play(player) {
        player.addResource(Resources_1.Resources.TITANIUM, 3);
        return undefined;
    }
}
exports.SpaceLanes = SpaceLanes;
//# sourceMappingURL=SpaceLanes.js.map